import React, { useEffect, useState, useCallback } from 'react';
import { db } from '../firebase';
import { collection, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import '../styles/Dasboard.css';

const Dashboard = () => {
    const [articles, setArticles] = useState([]);
    const [showInput, setShowInput] = useState(false);
    const [newArticleTitle, setNewArticleTitle] = useState('');
    const navigate = useNavigate();

    // Fetch articles from Firestore
    const fetchArticles = async () => {
        try {
            const articlesCollection = collection(db, 'articles');
            const articlesSnapshot = await getDocs(articlesCollection);
            const articlesList = articlesSnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setArticles(articlesList);
        } catch (error) {
            console.error('Error fetching articles:', error);
        }
    };

    useEffect(() => {
        fetchArticles();
    }, []);

    // Memoize handleEdit
    const handleEdit = useCallback((articleId) => {
        navigate(`/edit/${articleId}`);
    }, [navigate]);

    const handleFlip = () => {
        navigate('/flipbook');
    };

    // Show input box for new article
    const handleShowInput = () => {
        setShowInput(true);
    };

    // Create a new article in Firestore and navigate to the edit page
    const handleAddArticle = async () => {
        if (!newArticleTitle.trim()) {
            alert('Please enter an article title.');
            return;
        }

        try {
            const generatedSlug = newArticleTitle.toLowerCase().replace(/\s+/g, "-"); // Create slug

            const newArticle = {
                title: newArticleTitle,
                category: 'Uncategorized',
                featured: false,
                createdAt: new Date(),
                content: '',
                endpoint: generatedSlug, // Save only the slug
                summary: '',
                imageUrl: '',
            };

            const docRef = await addDoc(collection(db, 'articles'), newArticle);
            const newArticleWithId = { ...newArticle, id: docRef.id };

            setArticles((prevArticles) => [...prevArticles, newArticleWithId]);
            alert('Article created successfully.');
            navigate(`/edit/${docRef.id}`);
        } catch (error) {
            console.error('Error creating article:', error);
            alert('Failed to create the article. Please try again.');
        }
    };

    // Memoize handleDelete
    const handleDelete = useCallback(async (articleId) => {
        if (window.confirm('Are you sure you want to delete this article?')) {
            try {
                await deleteDoc(doc(db, 'articles', articleId));
                setArticles((prevArticles) =>
                    prevArticles.filter((article) => article.id !== articleId)
                );
                alert('Article deleted successfully.');
            } catch (error) {
                console.error('Error deleting article:', error);
                alert('Failed to delete the article. Please try again.');
            }
        }
    }, []);

    // Memoize handleViewArticle
    const handleViewArticle = useCallback((endpoint) => {
        window.open(`http://honestaiengine.com/${endpoint}`, '_blank');
    }, []);

    // Memoize initializeDataTable
    const initializeDataTable = useCallback(() => {
        const table = $('#articles-table').DataTable({
            data: articles,
            columns: [
                { title: 'Title', data: 'title' },
                { title: 'Category', data: 'category' },
                { title: 'Featured', data: 'featured', render: (data) => (data ? 'Yes' : 'No') },
                {
                    title: 'Created At',
                    data: 'createdAt',
                    render: (data) => (data ? new Date(data.seconds * 1000).toLocaleString() : 'N/A'),
                },
                {
                    title: 'Actions',
                    render: (data, type, row) => `
                        <button class="edit-button" data-id="${row.id}">Edit</button>
                        <button class="delete-button" data-id="${row.id}">Delete</button>
                        <button class="view-button" data-endpoint="${row.endpoint}">View</button>
                    `,
                },
            ],
            destroy: true,
            paging: true,
            searching: true,
            info: true,
            autoWidth: false,
        });

        $('#articles-table tbody').off('click', '.edit-button');
        $('#articles-table tbody').on('click', '.edit-button', function () {
            const articleId = $(this).data('id');
            handleEdit(articleId);
        });

        $('#articles-table tbody').off('click', '.delete-button');
        $('#articles-table tbody').on('click', '.delete-button', function () {
            const articleId = $(this).data('id');
            handleDelete(articleId);
        });

        $('#articles-table tbody').off('click', '.view-button');
        $('#articles-table tbody').on('click', '.view-button', function () {
            const endpoint = $(this).data('endpoint');
            handleViewArticle(endpoint);
        });

        return table;
    }, [articles, handleEdit, handleDelete, handleViewArticle]); // Add dependencies

    useEffect(() => {
        const table = initializeDataTable();
        table.clear().rows.add(articles).draw();

        return () => {
            table.destroy();
        };
    }, [initializeDataTable, articles]); // Add initializeDataTable to the dependency array

    const handleLogout = () => {
        signOut(auth)
            .then(() => navigate('/'))
            .catch((error) => {
                console.error('Logout Error:', error);
                alert('Failed to logout. Please try again.');
            });
    };

    return (
        <div className="dashboard">
            <div className="dashboard-header">
                <h1>HonestAI Admin Dashboard</h1>
                <button onClick={handleFlip}>Chapter Dashboard</button>

                {!showInput ? (
                    <button className="add-article-button" onClick={handleShowInput}>
                        ➕ Add Article
                    </button>
                ) : (
                    <div className="add-article-input">
                        <input
                            type="text"
                            placeholder="Enter article title..."
                            value={newArticleTitle}
                            onChange={(e) => setNewArticleTitle(e.target.value)}
                        />
                        <button onClick={handleAddArticle}>Go</button>
                    </div>
                )}

                <button className="logout-button" onClick={handleLogout}>
                    Logout
                </button>
            </div>

            <table id="articles-table" className="display">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Category</th>
                        <th>Featured</th>
                        <th>Created At</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </div>
    );
};

export default Dashboard;